<template>
    <q-field label="Kategoria"
             :error="validate && $v.localCategory.$error"
             error-label="Pole nie może być puste">
        <q-select
            v-model="localCategory"
            :inline="true"
            :options="categories"
            @input="inputChanged"
        />
        <span>
            Brak kategorii? <a href="#" @click.prevent="showAddForm">Dodaj</a>.
        </span>
    </q-field>
</template>

<script>
    import QAutocomplete from 'quasar-framework/src/components/autocomplete/QAutocomplete'
    import QInput from 'quasar-framework/src/components/input/QInput'
    import QField from 'quasar-framework/src/components/field/QField'
    import QBtn from 'quasar-framework/src/components/btn/QBtn'
    import QSelect from 'quasar-framework/src/components/select/QSelect'

    import {required, minLength} from 'vuelidate/lib/validators'

    export default {
        name: 'CategoryChooser',
        components: {QSelect, QBtn, QField, QInput, QAutocomplete},
        props: ['category', 'validate', 'kb'],
        data () {
            return {
                localCategory: '',
                newCategory: '',
            }
        },
        mounted () {
            this.localCategory = this.category

            this.doValidate()
        },
        watch: {
            category () {
                this.localCategory = this.category

                this.doValidate()
            }
        },
        methods: {
            showAddForm () {
                this.$q.dialog({
                    title: 'Podaj nazwę nowej kategorii',
                    prompt: {
                        model: '',
                        type: 'text'
                    },
                    cancel: true,
                    color: 'secondary'
                }).then(data => {
                    if (data && data.length > 0) {
                        const id  = this.$uuid()

                        const what = this.attrCategory

                        this.$store.dispatch('create', {
                            what,
                            item: {
                                ...this.kb ? {kbCategory: id} : {category: id},
                                label: data,
                                description: data
                            },
                            id
                        }).then(() => {
                            this.localCategory = id
                        })
                    } else {
                        this.$q.notify('Nazwa nie może być pusta')
                    }
                })
            },
            inputChanged (e) {
                this.doValidate();
                this.$emit('selected', e)
                this.$emit('valid', this.valid)
            },
            doValidate () {
                if (this.validate) {
                    this.$v.touch()
                    this.$emit('valid', !this.$v.$invalid)
                }
            }

        },
        computed: {
            categories () {
                const cc = this.$store.getters[ this.attrCategory ]
                return (cc || []).map(c => {
                    return {
                        label: c.label,
                        value: c[ this.attrCategory ]
                    }
                })
            },
            valid () {
                return ! this.$v.$invalid
            },
            attrCategory () {
                return this.kb ? 'kbCategory' : 'category'
            }

        },
        validations () {
            if (this.validate) {
                return {
                    localCategory: {
                        required,
                        minLength: minLength(1)
                    },
                }
            } else {
                return {}
            }
        },
    }
</script>

<style scoped>

</style>